<template>
  <div>
    <b-card no-body>
      <offer-summary />
    </b-card>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Ürünler</b-card-title>
      </b-card-header>
      <products />
    </b-card>
    <b-card title="Özel Şartlar">
      <terms />
      <div class="mt-1 text-center">
        <div class="d-inline">
          <b-button
            variant="warning"
            class="mr-2"
            :to="'/app/offers/edit/' + dataItem.id"
          >
            <FeatherIcon icon="EditIcon" />
            Güncelle
          </b-button>
        </div>
        <div class="d-inline">
          <b-button
            variant="info"
            class="mr-2"
            :to="'/app/offers/revised/' + dataItem.id"
          >
            <FeatherIcon icon="EditIcon" />
            Revize Oluştur
          </b-button>
        </div>
        <div
          v-if="dataItem.id_offer_statuses === '1'"
          class="d-inline"
        >
          <b-button
            variant="success"
            class="mr-2"
            @click="confirmOffer()"
          >
            <FeatherIcon icon="CheckSquareIcon" />
            Teklifi Onayla
          </b-button>
        </div>
        <div
          v-if="dataItem.id_offer_statuses === '1'"
          class="d-inline"
        >
          <b-button
            variant="danger"
            class="mr-2"
            @click="declineOffer()"
          >
            <FeatherIcon icon="XSquareIcon" />
            Teklifi Reddet
          </b-button>
        </div>
        <div
          v-if="dataItem.id_offer_statuses !== '1'"
          class="d-inline"
        >
          <b-dropdown
            id="print"
            variant="success"
            class="mr-2"
          >
            <template #button-content>
              <FeatherIcon icon="PrinterIcon" />
              Yazdır
            </template>
            <b-dropdown-item @click="download('tr')">
              Türkçe
            </b-dropdown-item>
            <b-dropdown-item @click="download('en')">
              İngilizce
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div
          v-if="dataItem.id_offer_statuses !== '1'"
          class="d-inline"
        >
          <b-button
            variant="danger"
            class="mr-2"
            @click="toggleMailForm"
          >
            <FeatherIcon icon="MailIcon" />
            E-posta
          </b-button>
        </div>
      </div>
    </b-card>
    <mail-form v-if="emailForm" />
    <mail-logs v-if="emailForm" />
  </div>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BButton, BDropdownItem, BDropdown,
} from 'bootstrap-vue'
import OfferSummary from '@/views/Admin/Offers/View/OfferSummary.vue'
import Products from '@/views/Admin/Offers/View/Products.vue'
import Terms from '@/views/Admin/Offers/View/Terms.vue'
import MailForm from '@/views/Admin/Offers/View/MailForm.vue'
import MailLogs from '@/views/Admin/Offers/View/MailLogs.vue'

export default {
  name: 'OffersView',
  components: {
    MailLogs,
    MailForm,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
    OfferSummary,
    Products,
    Terms,
  },
  props: {
    getData: {
      type: Function,
      required: false,
    },
    confirmOffer: {
      type: Function,
      required: true,
    },
    declineOffer: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      emailForm: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['offers/dataItem']
    },
    customerSend() {
      return this.$store.getters['offers/customerSend']
    },
  },
  methods: {
    download(lang) {
      window.open(`${this.$store.state.app.baseURL}/Exports/offers/pdf?token=${localStorage.getItem('downloadToken')}&id=${this.$route.params.id}&lang=${lang}`, '_blank')
    },
    submitCustomer() {
      this.customerSend.modalStatus = true
      this.getCustomerAccounts()
    },
    getCustomerAccounts() {
      this.$store.dispatch('customerAccounts/getDataList', {
        select: [
          'customer_accounts.id AS id',
          'customer_accounts.fullname AS title',
          'customer_accounts.email AS email',
        ],
        where: {
          'customer_accounts.id_customers': this.dataItem.id_customers,
          'customer_accounts.status': 1,
        },
      })
    },
    toggleMailForm() {
      this.emailForm = !this.emailForm
    },
  },
}
</script>
